<app-alert></app-alert>
<section class="card">

  <div class="card-header">
    <span class="cat__core__title">
      <strong id="pageTitle">Register of Investments (other than securities not held in the name of the company)</strong>
    </span>
    <span style="float: right">
      <!-- <a routerLink="/investment-list"> -->
        <button (click)="back()"  class="btn btn-sm btn-default pull-right btn-back" type="button">
          <i class=" fa fa-chevron-circle-left"></i>
          Back
        </button>
      <!-- </a> -->
    </span>
    <!-- <span style="float:right">
      <button class="btn btn-success pull-right" class="btn btn-sm btn-primary" style="margin-right: 8px;" (click)="generateOutput()" type="button"  *ngIf="!addBtn">
        <span>
          <i class="fa fa-save"></i>Generate Output</span>
      </button>
</span> -->
  </div>



  <form [formGroup]='investmentForm' (document:click)="a.close();b.close();c.close();d.close()">
    <div class="modal-body">
      <div class="row">

        <div class="form-group col-md-4 col-sm-6 col-xs-12">
          <label>Name of the person, in whose name the investments are held
            <span _ngcontent-c2="" style="color: red;">*</span>
          </label>

          <input type="text" class="form-control" [formControl]="investmentForm.controls['nameOfPerson']" tabindex="1" autocomplete="off"
            required>
          <div *ngIf="investmentForm.controls['nameOfPerson'].hasError('required') && investmentForm.controls['nameOfPerson'].touched"
            class="form-control-error-custom">
            Name of Person is required
          </div>
        </div>

        <div class="form-group col-md-4 col-sm-6 col-xs-12"><br>
          <label>Date of Acquisition</label>
          <span _ngcontent-c2="" style="color: red;">*</span>
          <div class="input-group" (click)="$event.stopPropagation()">
            <input class="form-control" [formControl]="investmentForm.controls['DateOfAcquisition']" [(ngModel)]="DateOfAcquisitionModel"
              style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="acquisitiondate" ngbDatepicker #a="ngbDatepicker"
              (click)="a.toggle()">
            <button class="input-group-addon" (click)="a.toggle()" type="button">
              <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
            </button>
          </div>
          <div *ngIf="investmentForm.controls['DateOfAcquisition'].hasError('required') && investmentForm.controls['DateOfAcquisition'].touched"
            class="form-control-error-custom">
            Date of Acquisition is required.
          </div>

        </div>

        <div class="form-group col-md-4 col-sm-6 col-xs-12"><br>
          <label>Description of Properties</label>
          <input type="text" class="form-control" [formControl]="investmentForm.controls.descriptionOfProperties">

        </div>
      </div>

      <div class="row">

        <div class="form-group col-md-4 col-sm-6 col-xs-12"><br>
          <label>List of Documents by which the property was acquired</label>
          <textarea class="form-control" [formControl]="investmentForm.controls.listOfdocuments"></textarea>

        </div>

        <div class="form-group col-md-4 col-sm-6 col-xs-12">
          <label>Reasons for which title not yet passed in the name of the Company</label>
          <textarea class="form-control" [formControl]="investmentForm.controls.reasons"></textarea>

        </div>

        <div class="form-group col-md-4 col-sm-6 col-xs-12"><br>
          <label>Date of Board Resolution authorising the transaction</label>
          <div class="input-group" (click)="$event.stopPropagation()">
            <input class="form-control" [formControl]="investmentForm.controls['DateOfBoard']" [(ngModel)]="DateOfBoardModel" style="padding:6px;z-index: 0;"
              placeholder="dd-mm-yyyy" name="boarddate" ngbDatepicker #b="ngbDatepicker" (click)="b.toggle()">
            <button class="input-group-addon" (click)="b.toggle()" type="button">
              <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
            </button>
          </div>

        </div>
      </div>

      <div class="row">

        <div class="form-group col-md-4 col-sm-6 col-xs-12">
          <label>Upload Board Resolution CTC</label>
          <div class="form-group">
            <input type="file" class="form-control" *ngIf="!boardFileAvailable" (change)="boardFileChangeEvent($event)">
            <div *ngIf="boardFileAvailable">
              <input data-toggle="tooltip" [title]="boardCtc" type="text" [formControl]="investmentForm.controls['boardCtc']" [(ngModel)]="boardCtc"
                class='form-control col-md-6' readonly='true' style="display: inline-block;">
              <button type="button" class="btn-sm btn btn-primary form-control col-md-2" (click)='downloadCtcDoc(boardCtcDocId);'>
                <i class="fa fa-download"></i>
              </button>
              <button type="button" class="btn-sm btn btn-primary form-control col-md-3" (click)='addBoardFilesOnUpdate();'>Add New</button>
            </div>
            <span style="color: red" *ngIf="!fileExtension">Please upload valid file only.</span>
          </div>
        </div>

        <div class="form-group col-md-4 col-sm-6 col-xs-12">
          <label>Date of Shareholder Resolution, if any</label>
          <div class="input-group" (click)="$event.stopPropagation()">
            <input class="form-control" [formControl]="investmentForm.controls['DateOfShareholderResolution']" [(ngModel)]="DateOfShareholderResolutionModel"
              style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="shareholderdate" ngbDatepicker #c="ngbDatepicker"
              (click)="c.toggle()">
            <button class="input-group-addon" (click)="c.toggle()" type="button">
              <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
            </button>
          </div>

        </div>


        <div class="form-group col-md-4 col-sm-6 col-xs-12">
          <label>Upload Shareholder Resolution CTC</label>
          <div class="form-group">
            <input type="file" class="form-control" *ngIf="!shareholderFileAvailable" (change)="shareHolderFileChangeEvent($event)">
            <div *ngIf="shareholderFileAvailable">
              <input data-toggle="tooltip" [title]="shareholderCtc" type="text" [formControl]="investmentForm.controls['shareholderCtc']"
                [(ngModel)]="shareholderCtc" class='form-control col-md-6' readonly='true' style="display: inline-block;">
              <button type="button" class="btn-sm btn btn-primary form-control col-md-2" (click)='downloadCtcDoc(shareholderCtcDocId);'>
                <i class="fa fa-download"></i>
              </button>
              <button type="button" class="btn-sm btn btn-primary form-control col-md-3" (click)='addShareholderFilesOnUpdate();'>Add New</button>
            </div>
            <span style="color: red" *ngIf="!checkFileExtension">Please upload valid file only.</span>
          </div>
        </div>


      </div>

      <div class="row">

        <div class="form-group col-md-4 col-sm-6 col-xs-12">
          <label>Quantum of Investment</label>
          <input type="text" class="form-control" [formControl]="investmentForm.controls.quantumOfInvestment">

        </div>

        <div class="form-group col-md-4 col-sm-6 col-xs-12">
          <label>Date of title in the Name of the Company</label>
          <div class="input-group" (click)="$event.stopPropagation()">
            <input class="form-control" [formControl]="investmentForm.controls['dateOftitle']" [(ngModel)]="dateOftitleModel" style="padding:6px;z-index: 0;"
              placeholder="dd-mm-yyyy" name="titledate" ngbDatepicker #d="ngbDatepicker" (click)="d.toggle()">
            <button class="input-group-addon" (click)="d.toggle()" type="button">
              <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
            </button>
          </div>

        </div>

        <div class="form-group col-md-4 col-sm-6 col-xs-12">
          <label>Description of title in the Name of the Company</label>
          <textarea class="form-control" [formControl]="investmentForm.controls.descriptionOftitle"></textarea>

        </div>
      </div>

      <div class="form-group col-md-12 col-sm-6 col-xs-12">
        <label>Remarks, if any</label>
        <textarea class="form-control" [formControl]="investmentForm.controls.remarks" maxlength="200"></textarea>

      </div>

    </div>

    <div class="card-footer" align="right">
      <!--<div class="form-actions" style="text-align: right">-->

      <button class="btn btn-sm btn-primary" type="button" (click)="saveInvestmentData()" [disabled]="!investmentForm.valid || disabledOnclick || !fileExtension || !checkFileExtension" *ngIf="addBtn">Save</button>
      <!-- <button class="btn btn-sm btn-primary" (click)="generateOutput()" type="button" *ngIf="!addBtn">
        <span>
          <i class="fa fa-save"></i>Generate Output </span>
      </button> -->
      <button class="btn btn-sm btn-primary" type="button" (click)="updateBankAccountParticulars(ParticularId._id)" [disabled]="!investmentForm.valid || disabledOnclick || !fileExtension || !checkFileExtension"
        *ngIf="!addBtn">Update</button>
    </div>
    <!--</div>-->
  </form>


</section>